import { render, staticRenderFns } from "./TextLimitsWidget.vue?vue&type=template&id=752e4614&scoped=true&lang=pug"
import script from "./TextLimitsWidget.vue?vue&type=script&lang=js"
export * from "./TextLimitsWidget.vue?vue&type=script&lang=js"
import style0 from "./TextLimitsWidget.vue?vue&type=style&index=0&id=752e4614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e4614",
  null
  
)

export default component.exports